module.exports = __webpack_public_path__ + "img/card_program@3x.261b4dd6.png";